<template>
  <div class="row" :class="{gameComplete: gameComplete}">
    <!-- The Game -->
    <div class="testContentContainer  testContentContainer--game">
      <div class="testContent--game">
        <div class="content">
          <div class="row gameRowContainer">
            <!-- game explanation -->
            <div class="descriptionContainer">
              <h3 class="pageTitle">{{ gameData.gameTitle }}</h3>
              <p v-html="gameData.gameCopy" v-if="downloaded && gameData.gameCopy"></p>
              <p v-else>{{ gameData.gameDescription }}</p>
              
              <a v-if="downloaded" class="gameButton gameButton--second" @click="resetGame()">Reset</a>
              <a class="gameButton gameButton--first" @click="nextPage()">Skip</a>
            </div>

            <div class="gameContainer" :class=" {'loading': this.gameLoader}">
              <div class="loader loader--center"></div>

              <!-- game start screen -->  
              <a class="startGameLink" :class="imageClass" v-if="!downloaded" @click="playGame()">
                <img class="playButtonImage" src="../../assets/images/games/Play_Button.svg">
              </a>

              <!-- game play screen -->
              <div v-else>
                <div :id="gameData.gameName + 'Game-container'" class="content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>      
      <div class="container" style="max-width: 100%;">
        <div class="row">
          <progressCmp :prevLink="gameData.prevQuestion"></progressCmp>
        </div>      
      </div>
    </div>

    <!-- The Game Results -->
    
    <gameResultCmp 
      v-if="gameComplete"
      @nextPage='nextPage' 
      :gameName="gameData.gameName"
      :goodMoves="recordMoves"
      :goodTime="recordTime"
    ></gameResultCmp>
  </div>
</template>
<script>
export default {
  props: ['gameData'],
  data() {
    return {
      gameComplete: false,
      recordMoves: false,
      currentGame: null,
      recordTime: false,
      downloaded: false,
      imageClass: null,
      playing: false
    }
  },
  beforeRouteLeave (to, from, next) {
    this.destroyGame()
    next()
  },
  mounted () {
    this.imageClass = 'startGameLink--' + this.gameData.gameName
  },
  computed: {
    gameResult () {
      return this.$store.getters.StoreGameData[this.gameData.gameName]
    },
    gameLoader () {
      return this.$store.getters.StoreQuestionData.gameLoading
    }
  },
  methods: {
    playGame () {
      if (!this.loading && !this.downloaded) {
        this.$store.dispatch('updateLoader', true)

        import('@/game/' + this.gameData.gameName + '/game').then(game => {
          this.downloaded = true
          this.$nextTick(() => game.launch())
          this.currentGame = game
        })
      }
    },
    gameWin () {
      this.recordMoves = this.gameResult.moves < this.gameData.bestMoves
      this.recordTime = this.gameResult.time < this.gameData.bestTime

      this.gameComplete = true
    },
    nextPage () {

      this.$store.dispatch('updatePlayingGame', false)
      this.$store.dispatch('saveData', {game: this.gameData.gameName, data: {complete: true}})
      if (this.$route.query.replay) {
        this.$router.push('/result?replay=true')
      } else {
        this.$router.push('/' + this.gameData.nextQuestion)
      }
    },
    resetGame () {
      this.currentGame.resetGame()
    },
    destroyGame () {
      this.currentGame.destroyGame()
    }
  },
  watch: {
    gameResult () {
      if (this.gameResult.complete) {
        this.gameWin()
      }
    }
  }
}
</script>